(function () {
  'use strict';

  var carreraLensOverrides = {
    'carrera-1030-s-polarised|003M9': 'Grey polarised',
    'carrera-1043-s-polarised|807WJ': 'Blue gradient with light mirror polarised',
    'carrera-1055-s-polarised|V81M9': 'Grey polarised',
    'carrera-1058-s-polarised|08AM9': 'Grey polarised',
    'carrera-22-n|2M2HA': 'Brown gradient',
    'carrera-22-n|T4O9O': 'Grey gradient',
    'carrera-22-n-polarised|2M2YL': 'Gold mirror polarised',
    'carrera-22-n-polarised|7C5M9': 'Grey polarised',
    'carrera-27-polarised|80SWJ': 'Grey polarised',
    'carrera-27-polarised|R60LA': 'Brown gradient polarised',
    'carrera-3005-s-polarised|06JLA': 'Brown gradient polarised',
    'carrera-3028-s-polarised|WR9LA': 'Brown gradient polarised',
    'carrera-3028-s-polarised|807WJ': 'Grey gradient polarised',
    'carrera-305-s-polarised|807M9': 'Grey polarised',
    'carrera-8064-s-polarised|08AM9': 'Grey polarised',
    'carrera-8064-s-polarised|OITQ3': 'Red mirror polarised',
    'carrera-grand-prix-2-polarised|7C5M9': 'Grey polarised',
    'carrera-grand-prix-2-polarised|OITWJ': 'Grey gradient polarised',
    'carrera-grand-prix-2-pat-cummins-polarised|7ZJWJ': 'Grey gradient polarised',
    'carrera-speedway-n|2M2HA': 'Brown gradient',
    'carrera-speedway-n|P9UHA': 'Brown gradient',
    'carrera-speedway-n|T5C9O': 'Grey gradient',
    'carrera-speedway-n|T4090': 'Dark grey gradient',
    'carrera-victory-c-01-s-polarised|807WJ': 'Grey gradient polarised',
    'carrera-victory-c-03-s-polarised|807M9': 'Grey polarised'
  };

  var frameColourOverrides = {
    'Matte Sand Dark Blue': 'Matte Sand / Dark Blue',
    'Polished Sand Dark Blue': 'Polished Sand / Dark Blue',
    'Matte Sand Black': 'Matte Sand / Black',
    'Matte Sand Brown': 'Matte Sand / Brown'
  };

  function parseMap(picker, selector) {
    var script = picker.querySelector(selector);
    if (!script) return {};
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return {};
    }
  }

  function normalise(value) {
    return String(value || '').trim().replace(/\s+/g, ' ');
  }

  function containsPolarised(value) {
    return /polari[sz]ed/i.test(String(value || ''));
  }

  function lensDisplay(rawValue, vendor) {
    var value = normalise(rawValue);
    if (!value) return '';

    value = value.replace(/\s+polari[sz]ed\+?\s*$/i, '');

    return normalise(value.replace(/polarized/gi, 'polarised'));
  }

  function technologyLabel(vendor, evidence) {
    if (vendor === 'Carrera' && /ultra\s*polari[sz]ed/i.test(evidence)) return 'Carrera Ultra Polarised';
    if (vendor === 'Ray-Ban' && /polari[sz]ed\+/i.test(evidence)) return 'Ray-Ban Polarized+';
    if (vendor === 'Oakley' && /prizm/i.test(evidence)) {
      return containsPolarised(evidence) ? 'Oakley Prizm Polarized' : 'Oakley Prizm';
    }
    return containsPolarised(evidence) ? 'Polarised' : '';
  }

  function oakleyLensSummary(lens, evidence) {
    var value = normalise(lens);
    var hasPrizm = /prizm/i.test([value, evidence].join(' '));
    var isPolarised = containsPolarised(evidence);
    if (hasPrizm && !/prizm/i.test(value)) value = normalise('Prizm ' + value);
    if (isPolarised && !containsPolarised(value)) value = normalise(value + ' Polarised');
    return value;
  }

  function frameColourDisplay(optionValue, vendor) {
    var value = normalise(optionValue);
    if (!['Ray-Ban', 'Oakley'].includes(vendor)) return value;
    var parts = value.split(/\s+\/\s+/).map(normalise).filter(Boolean);
    var frameColour = parts.length > 1 ? parts.slice(0, -1).join(' / ') : value;
    return frameColourOverrides[frameColour] || frameColour;
  }

  function initPicker(picker) {
    if (!picker || picker.dataset.cityColourCopyReady === 'true') return;
    picker.dataset.cityColourCopyReady = 'true';

    var variantsScript = Array.from(picker.querySelectorAll('script[type="application/json"]')).find(function (script) {
      return !script.hasAttribute('data-city-sun-frame-code-map') &&
        !script.hasAttribute('data-city-sun-lens-colour-map') &&
        !script.hasAttribute('data-city-sun-custom-polarised-eligible-map');
    });
    if (!variantsScript) return;

    var variants = [];
    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch (error) {
      return;
    }

    var frameCodes = parseMap(picker, '[data-city-sun-frame-code-map]');
    var lensColours = parseMap(picker, '[data-city-sun-lens-colour-map]');
    var colourGroup = picker.querySelector('[data-city-sun-option-role="color"]');
    var lensGroup = picker.querySelector('[data-city-sun-option-role="lens"]');
    if (!colourGroup) return;

    var colourIndex = Number(colourGroup.dataset.citySunOptionIndex);
    var lensIndex = lensGroup ? Number(lensGroup.dataset.citySunOptionIndex) : -1;
    var vendor = picker.dataset.productVendor || '';
    var handle = picker.dataset.productHandle || '';

    function selectedLensValue() {
      var selected = lensGroup ? lensGroup.querySelector('input[type="radio"]:checked') : null;
      return selected ? selected.value : '';
    }

    function variantForColour(colour, lensValue) {
      var colourVariants = variants.filter(function (variant) {
        return variant.options && variant.options[colourIndex] === colour;
      });
      if (lensIndex >= 0 && lensValue) {
        var exactVariant = colourVariants.find(function (variant) {
          return variant.options[lensIndex] === lensValue;
        });
        if (exactVariant) return exactVariant;
      }
      return colourVariants[0] || null;
    }

    function rawLensColour(variant) {
      if (!variant) return '';
      var raw = normalise(lensColours[String(variant.id)]);
      if (!raw && vendor === 'Carrera') {
        raw = normalise(carreraLensOverrides[handle + '|' + normalise(frameCodes[String(variant.id)])]);
      }
      return raw;
    }

    function update() {
      var lensValue = selectedLensValue();
      var selectedInput = colourGroup.querySelector('input[type="radio"]:checked');
      var selectedHeading = colourGroup.querySelector('[data-selected-swatch-value]');
      if (selectedHeading && selectedInput) {
        selectedHeading.textContent = frameColourDisplay(selectedInput.value, vendor);
      }
      colourGroup.querySelectorAll('input[type="radio"]').forEach(function (input) {
        var label = colourGroup.querySelector('label[for="' + input.id + '"]');
        if (!label) return;
        var variant = variantForColour(input.value, lensValue);
        var rawLens = rawLensColour(variant);
        var evidence = [rawLens, variant ? variant.title : ''].join(' ');
        var lens = lensDisplay(rawLens, vendor);
        var technology = technologyLabel(vendor, evidence);
        var secondary = label.querySelector('[data-city-sun-lens-summary]');
        var primary = label.querySelector('[data-city-sun-frame-colour]');
        if (primary) primary.textContent = frameColourDisplay(input.value, vendor);
        if (secondary) {
          secondary.textContent = vendor === 'Oakley'
            ? oakleyLensSummary(lens, evidence)
            : [lens, technology].filter(Boolean).join(' · ');
          secondary.hidden = !secondary.textContent;
        }
      });
    }

    picker.addEventListener('change', function () {
      window.setTimeout(update, 0);
    });
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-city-sunglass-selects]').forEach(initPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
